var state = {
    itemDiscounts: {},
    currentDiscountDeltas: {},
    currentDiscountBasePrices: {},
    currentDiscountedPrice: 0,
};
var getters = {
    getDiscounts: function (state) {
        return state.currentDiscountDeltas;
    },
    getBasePriceForItem: function (state) { return function (uniqueId) {
        return state.currentDiscountBasePrices[uniqueId];
    }; },
    discountForItem: function (state) { return function (itemId) {
        return state.itemDiscounts[itemId];
    }; },
    currentDiscountedPrice: function (state) {
        return state.currentDiscountedPrice;
    }
};
var actions = {
    setDiscountForItem: function (_a, _b) {
        var commit = _a.commit;
        var itemId = _b.itemId, discount = _b.discount;
        commit('setDiscountForItem', {
            itemId: itemId,
            discount: discount,
        });
    },
    addDiscount: function (_a, _b) {
        var commit = _a.commit;
        var uniqueId = _b.uniqueId, amount = _b.amount;
        commit('addDiscount', {
            uniqueId: uniqueId,
            amount: amount
        });
    },
    setCurrentDiscountedPrice: function (_a, amount) {
        var commit = _a.commit;
        commit('setCurrentDiscountedPrice', amount);
    },
    setBasePriceForItem: function (_a, _b) {
        var commit = _a.commit;
        var uniqueId = _b.uniqueId, basePrice = _b.basePrice;
        commit('setBasePriceForItem', {
            uniqueId: uniqueId,
            basePrice: basePrice,
        });
    },
    clearDiscounts: function (_a) {
        var commit = _a.commit;
        commit('clearDiscounts');
    },
};
var mutations = {
    setDiscountForItem: function (state, _a) {
        var itemId = _a.itemId, discount = _a.discount;
        state.itemDiscounts[itemId] = discount;
    },
    addDiscount: function (state, _a) {
        var uniqueId = _a.uniqueId, amount = _a.amount;
        state.currentDiscountDeltas[uniqueId] = amount;
    },
    setBasePriceForItem: function (state, _a) {
        var uniqueId = _a.uniqueId, basePrice = _a.basePrice;
        state.currentDiscountBasePrices[uniqueId] = basePrice;
    },
    setCurrentDiscountedPrice: function (state, amount) {
        state.currentDiscountedPrice = amount;
    },
    clearDiscounts: function (state) {
        state.currentDiscountDeltas = {};
        state.currentDiscountBasePrices = {};
        state.currentDiscountedPrice = 0;
        state.itemDiscounts = {};
    }
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/discount.store.ts
// module id = null
// module chunks = 